"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var HashtagIcon = function HashtagIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.45,14.69H17.62a.13.13,0,0,1-.14-.13V9.44a.13.13,0,0,1,.14-.13h1.83a1.47,1.47,0,0,0,1.05-.45,1.37,1.37,0,0,0,.37-1,1.4,1.4,0,0,0-1.39-1.3H17.62a.13.13,0,0,1-.14-.13V4.55a1.43,1.43,0,0,0-.45-1A1.37,1.37,0,0,0,16,3.13a1.4,1.4,0,0,0-1.29,1.39V6.38a.13.13,0,0,1-.13.13H9.44a.13.13,0,0,1-.13-.13V4.55a1.44,1.44,0,0,0-.46-1,1.33,1.33,0,0,0-1-.37,1.4,1.4,0,0,0-1.3,1.39V6.38a.13.13,0,0,1-.13.13H4.55A1.44,1.44,0,0,0,3.5,7a1.37,1.37,0,0,0-.37,1A1.4,1.4,0,0,0,4.52,9.31H6.38a.13.13,0,0,1,.13.13v5.12a.13.13,0,0,1-.13.13H4.55a1.47,1.47,0,0,0-1,.45,1.37,1.37,0,0,0-.37,1.05,1.4,1.4,0,0,0,1.39,1.3H6.38a.13.13,0,0,1,.13.13v1.83A1.44,1.44,0,0,0,7,20.5a1.34,1.34,0,0,0,1,.37,1.4,1.4,0,0,0,1.3-1.39V17.62a.13.13,0,0,1,.13-.13h5.12a.13.13,0,0,1,.13.13v1.83a1.43,1.43,0,0,0,.45,1.05,1.38,1.38,0,0,0,.94.37h.11a1.39,1.39,0,0,0,1.29-1.39V17.62a.13.13,0,0,1,.14-.13h1.86a1.4,1.4,0,0,0,1.39-1.3,1.37,1.37,0,0,0-.37-1.05A1.47,1.47,0,0,0,19.45,14.69Zm-4.76-.13a.13.13,0,0,1-.13.13H9.44a.13.13,0,0,1-.13-.13V9.44a.13.13,0,0,1,.13-.13h5.12a.13.13,0,0,1,.13.13Z"
  }));
};

var _default = HashtagIcon;
exports["default"] = _default;
//# sourceMappingURL=Hashtag.js.map